var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7896 17.376L13.9908 9.18138L17.4885 5.68368C18.9875 4.18467 19.4872 2.18599 18.9875 1.18664C17.9882 0.686973 15.9895 1.18664 14.4905 2.68566L10.9928 6.18335L2.79817 4.38454C2.2985 4.2846 1.89877 4.48447 1.6989 4.88421L1.3991 5.38388C1.19923 5.88355 1.29916 6.38322 1.6989 6.68302L6.99541 10.1807L4.99673 13.1787H1.9987L0.999359 14.1781L3.99738 16.1768L5.99607 19.1748L6.99541 18.1755V15.1774L9.99343 13.1787L13.4911 18.4753C13.7909 18.875 14.2906 18.9749 14.7903 18.7751L15.2899 18.5752C15.6897 18.2754 15.8895 17.8756 15.7896 17.376Z",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightWhite);
export default __webpack_public_path__ + "static/media/flightWhite.aed30574b8d76aef5c3d014e47003c21.svg";
export { ForwardRef as ReactComponent };